module.exports = __webpack_public_path__ + "img/Estrateca.4b5cebb9.png";